// Cloudflare Turnstile Site Key
export const TURNSTILE_SITE_KEY = '0x4AAAAAACH0M67zAtDzTKEL';

// Global token storage for use in axios interceptor
let globalTurnstileToken: string | null = null;

export function setGlobalTurnstileToken(token: string | null): void {
  globalTurnstileToken = token;
}

export function getGlobalTurnstileToken(): string | null {
  return globalTurnstileToken;
}
